import Cookies from "js-cookie";
import { logger } from "./logger.mjs";
function getSavedLocation() {
  const location = sessionStorage.getItem("userLocation");
  if (!location) return null;
  return JSON.parse(location);
}
function setSavedLocation(location) {
  sessionStorage.setItem("userLocation", JSON.stringify(location));
}
function getCoordsFromAkamaiCookie() {
  const edgeLocation = Cookies.get("EdgeLocation");
  if (!edgeLocation) return null;
  const [lat, long] = edgeLocation.split(",");
  return {
    latitude: parseFloat(lat).toFixed(3),
    longitude: parseFloat(long).toFixed(3)
  };
}
function getCoordsFromBrowser() {
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, reject);
  });
}
async function getUserCoords() {
  if ("permissions" in navigator) {
    const permissions = await navigator.permissions.query({ name: "geolocation" });
    if (permissions.state === "granted") {
      const { coords } = await getCoordsFromBrowser();
      return {
        latitude: coords.latitude.toFixed(3),
        longitude: coords.longitude.toFixed(3)
      };
    }
  }
  return getCoordsFromAkamaiCookie();
}
async function getUserLocation() {
  let location = getSavedLocation();
  if (!location) {
    location = await getUserCoords();
  }
  return location;
}
function getPickupModalStore(lg = logger) {
  const pickupModalStoreData = sessionStorage.getItem("pickupModalStore");
  if (pickupModalStoreData) {
    try {
      const pickupModalStore = JSON.parse(pickupModalStoreData);
      return pickupModalStore;
    } catch (error) {
      lg.error("getPickupModalStore error", error);
      sessionStorage.removeItem("pickupModalStore");
      return void 0;
    }
  }
  return void 0;
}
function setPickupModalStore(store) {
  return sessionStorage.setItem("pickupModalStore", JSON.stringify(store));
}
export {
  getCoordsFromAkamaiCookie,
  getCoordsFromBrowser,
  getPickupModalStore,
  getSavedLocation,
  getUserCoords,
  getUserLocation,
  setPickupModalStore,
  setSavedLocation
};
//# sourceMappingURL=location.mjs.map
